var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: ["template-designer-v2", { "embedded-mode": _vm.embedded }] },
    [
      _c("div", { staticClass: "toolbar" }, [
        _c(
          "div",
          { staticClass: "toolbar-left" },
          [
            _c(
              "a-button",
              { attrs: { icon: "undo" }, on: { click: _vm.handleReset } },
              [_vm._v("\n        恢复默认模板\n      ")]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "toolbar-center" },
          [
            _c(
              "a-button-group",
              [
                _vm._l(_vm.paperTypes, function (paper, key) {
                  return _c(
                    "a-button",
                    {
                      key: key,
                      attrs: {
                        type: _vm.curPaperType === key ? "primary" : "default",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.setPaper(key, paper)
                        },
                      },
                    },
                    [_vm._v("\n          " + _vm._s(key) + "\n        ")]
                  )
                }),
                _c(
                  "a-button",
                  {
                    attrs: {
                      type:
                        _vm.curPaperType === "custom" ? "primary" : "default",
                    },
                    on: { click: _vm.showCustomPaperModal },
                  },
                  [_vm._v("\n          自定义\n        ")]
                ),
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "zoom-control" },
              [
                _c("a-button", {
                  attrs: {
                    icon: "minus",
                    disabled: _vm.scaleValue <= _vm.scaleMin,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeScale(false)
                    },
                  },
                }),
                _c("span", { staticClass: "scale-display" }, [
                  _vm._v(_vm._s(Math.round(_vm.scaleValue * 100)) + "%"),
                ]),
                _c("a-button", {
                  attrs: {
                    icon: "plus",
                    disabled: _vm.scaleValue >= _vm.scaleMax,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeScale(true)
                    },
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "toolbar-right" },
          [
            _c(
              "a-button",
              { attrs: { icon: "eye" }, on: { click: _vm.handlePreview } },
              [_vm._v("打印预览")]
            ),
            _c(
              "a-button",
              { attrs: { icon: "reload" }, on: { click: _vm.handleRefresh } },
              [_vm._v("刷新")]
            ),
            _c(
              "a-button",
              { attrs: { icon: "select" }, on: { click: _vm.selectAll } },
              [_vm._v("全选")]
            ),
            _c(
              "a-button",
              {
                attrs: { type: "primary", icon: "save" },
                on: { click: _vm.handleSave },
              },
              [_vm._v("保存")]
            ),
            _c(
              "a-button",
              { attrs: { icon: "delete" }, on: { click: _vm.handleClear } },
              [_vm._v("清空")]
            ),
            _c(
              "a-button",
              { attrs: { icon: "code" }, on: { click: _vm.showJsonModal } },
              [_vm._v("模板JSON")]
            ),
            !_vm.embedded
              ? _c(
                  "a-button",
                  { attrs: { icon: "close" }, on: { click: _vm.handleBack } },
                  [_vm._v("关闭")]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "a-modal",
        {
          staticStyle: { top: "200px" },
          attrs: {
            visible: _vm.customPaperModalVisible,
            title: "自定义纸张大小",
            footer: null,
            width: "400px",
          },
          on: {
            cancel: function ($event) {
              _vm.customPaperModalVisible = false
            },
          },
        },
        [
          _c("div", { staticClass: "custom-paper-form" }, [
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c("label", [_vm._v("宽度(mm)")]),
                _c("a-input-number", {
                  staticStyle: { width: "150px" },
                  attrs: { min: 20, max: 1000 },
                  model: {
                    value: _vm.paperWidth,
                    callback: function ($$v) {
                      _vm.paperWidth = $$v
                    },
                    expression: "paperWidth",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c("label", [_vm._v("高度(mm)")]),
                _c("a-input-number", {
                  staticStyle: { width: "150px" },
                  attrs: { min: 20, max: 1000 },
                  model: {
                    value: _vm.paperHeight,
                    callback: function ($$v) {
                      _vm.paperHeight = $$v
                    },
                    expression: "paperHeight",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-actions" },
              [
                _c(
                  "a-button",
                  {
                    on: {
                      click: function ($event) {
                        _vm.customPaperModalVisible = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "a-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.applyCustomPaper },
                  },
                  [_vm._v("确定")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticClass: "left-panel" }, [
          _c("div", { staticClass: "panel-header" }, [_vm._v("可用字段")]),
          _c("div", { staticClass: "panel-content" }, [
            _c("div", { staticClass: "hiprintEpContainer" }),
            !_vm.fieldPanelLoaded
              ? _c(
                  "div",
                  { staticClass: "loading-hint" },
                  [
                    _c("a-spin", { attrs: { size: "small" } }),
                    _vm._v(" 加载字段中...\n        "),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
        _c("div", { staticClass: "center-panel" }, [
          _c("div", { staticClass: "ruler" }),
          _c("div", {
            staticClass: "hiprint-printTemplate",
            attrs: { id: "hiprint-printTemplate" },
          }),
          _c("div", {
            staticClass: "hiprint-printPagination",
            staticStyle: { display: "none" },
          }),
          !_vm.templateLoaded
            ? _c(
                "div",
                { staticClass: "empty-state" },
                [_c("a-empty", { attrs: { description: "正在加载模板..." } })],
                1
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "right-panel" }, [
          _c("div", { staticClass: "panel-header" }, [_vm._v("属性设置")]),
          _c("div", { staticClass: "panel-content" }, [
            _c("div", {
              staticClass: "PrintElementOptionSetting",
              attrs: { id: "PrintElementOptionSetting" },
            }),
            !_vm.hasSelectedElement
              ? _c(
                  "div",
                  { staticClass: "selection-hint" },
                  [
                    _c("a-icon", { attrs: { type: "info-circle" } }),
                    _vm._v(" 点击画布上的元素以编辑属性\n        "),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.jsonModalVisible,
            title: "模板JSON编辑",
            width: "700px",
            footer: null,
          },
          on: {
            cancel: function ($event) {
              _vm.jsonModalVisible = false
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "json-modal-content" },
            [
              _c(
                "div",
                { staticClass: "json-toolbar" },
                [
                  _c("a-switch", {
                    attrs: {
                      "checked-children": "压缩",
                      "un-checked-children": "格式化",
                    },
                    model: {
                      value: _vm.jsonCompressed,
                      callback: function ($$v) {
                        _vm.jsonCompressed = $$v
                      },
                      expression: "jsonCompressed",
                    },
                  }),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link", size: "small" },
                      on: { click: _vm.formatJson },
                    },
                    [_vm._v("格式化")]
                  ),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link", size: "small" },
                      on: { click: _vm.compressJson },
                    },
                    [_vm._v("压缩")]
                  ),
                ],
                1
              ),
              _c("a-textarea", {
                attrs: { rows: 20, placeholder: "模板JSON内容" },
                model: {
                  value: _vm.templateJsonText,
                  callback: function ($$v) {
                    _vm.templateJsonText = $$v
                  },
                  expression: "templateJsonText",
                },
              }),
              _c(
                "div",
                { staticClass: "json-modal-footer" },
                [
                  _c(
                    "a-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.jsonModalVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.applyJson },
                    },
                    [_vm._v("应用")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.previewVisible,
            title: "打印预览",
            width: "90%",
            footer: null,
            wrapClassName: "preview-modal",
          },
          on: {
            cancel: function ($event) {
              _vm.previewVisible = false
            },
          },
        },
        [
          _c("div", { staticClass: "preview-container" }, [
            _c("div", { staticClass: "preview-settings" }, [
              _c(
                "div",
                { staticClass: "settings-section" },
                [
                  _c("h4", [_vm._v("设置")]),
                  _c("a-divider", { staticStyle: { margin: "8px 0" } }),
                  _c(
                    "div",
                    { staticClass: "setting-item" },
                    [
                      _c("span", [_vm._v("纸张大小")]),
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "100px" },
                          model: {
                            value: _vm.previewPaperSize,
                            callback: function ($$v) {
                              _vm.previewPaperSize = $$v
                            },
                            expression: "previewPaperSize",
                          },
                        },
                        [
                          _c("a-select-option", { attrs: { value: "A4" } }, [
                            _vm._v("A4"),
                          ]),
                          _c("a-select-option", { attrs: { value: "A5" } }, [
                            _vm._v("A5"),
                          ]),
                          _c("a-select-option", { attrs: { value: "B5" } }, [
                            _vm._v("B5"),
                          ]),
                          _c(
                            "a-select-option",
                            { attrs: { value: "Letter" } },
                            [_vm._v("Letter")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "setting-item" },
                    [
                      _c("span", [_vm._v("方向")]),
                      _c(
                        "a-radio-group",
                        {
                          model: {
                            value: _vm.previewOrientation,
                            callback: function ($$v) {
                              _vm.previewOrientation = $$v
                            },
                            expression: "previewOrientation",
                          },
                        },
                        [
                          _c("a-radio", { attrs: { value: "portrait" } }, [
                            _vm._v("纵向"),
                          ]),
                          _c("a-radio", { attrs: { value: "landscape" } }, [
                            _vm._v("横向"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "setting-item" },
                    [
                      _c("span", [_vm._v("缩放")]),
                      _c("a-slider", {
                        staticStyle: { width: "150px" },
                        attrs: { min: 50, max: 200 },
                        model: {
                          value: _vm.previewZoom,
                          callback: function ($$v) {
                            _vm.previewZoom = $$v
                          },
                          expression: "previewZoom",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "preview-actions" },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", icon: "printer", block: "" },
                      on: { click: _vm.doPrintFromPreview },
                    },
                    [_vm._v("打印")]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "preview-content-wrapper" }, [
              _c(
                "div",
                { staticClass: "preview-toolbar" },
                [
                  _c("span", [_vm._v("共 1 页")]),
                  _c("a-divider", { attrs: { type: "vertical" } }),
                  _c(
                    "a-button",
                    {
                      attrs: { size: "small", icon: "reload" },
                      on: { click: _vm.refreshPreview },
                    },
                    [_vm._v("刷新预览")]
                  ),
                ],
                1
              ),
              _c("div", { ref: "previewArea", staticClass: "preview-area" }, [
                _c(
                  "div",
                  {
                    staticClass: "preview-paper",
                    style: {
                      transform: `scale(${_vm.previewZoom / 100})`,
                      transformOrigin: "top center",
                    },
                  },
                  [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.previewHtml) },
                    }),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }